import React from 'react';
import PropTypes from 'prop-types';

// @material-ui
import { Face } from '@material-ui/icons';
import { Grid } from '@material-ui/core';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';

// core components
import Button from 'components/CustomButtons/Button';
import CustomSelectWithId from 'components/CustomInput/CustomSelectWithId';
import GridContainer from 'components/Grid/GridContainer';
import ItemGrid from 'components/Grid/ItemGrid';
import IconCard from 'components/Cards/IconCard';
import ErrorBoundaries from 'components/Wrapper/ErrorBoundaries';

// others
import { Context } from 'context/Context';
import FormHOC from 'hoc/FormHOC';
import detailsPageStyle from 'views/Common/style/detailsPageStyle';

import { DEPT_RESSOURCES_NON_REP } from 'data';

class StudentRegisterNonRep extends React.Component {
  state = {
    departmentSelected: '',
  };

  handleChangeDepartment = (event) => {
    DEPT_RESSOURCES_NON_REP.forEach((department) => {
      if (department._id === event.target.value) {
        this.setState({ departmentSelected: department });
        return;
      }
    });
  };

  splitLink = (link) => {
    var indexEndOfBaseUrl = link.indexOf('/', 8);
    if (indexEndOfBaseUrl != -1) {
      return link.slice(0, link.indexOf('/', 8) + 1);
    }
    return link;
  };

  render() {
    const { classes } = this.props;
    const { departmentSelected } = this.state;

    const content = (
      <div className={classes.topMargin}>
        {/* Texte d'intro */}
        <p>
          Ton collège n&apos;est pas REP, tu ne peux pas avoir accès à notre liste de stage. Mais on va tout de même
          t&apos;aider en te redirigeant vers des sites qui pourront t&apos;accompagner dans ta recherche de stage.
        </p>
        {/* Sélection département */}
        <div className={classes.topMargin}>
          <CustomSelectWithId
            className={classes.topMargin}
            multiple={false}
            labelText='Département'
            data={DEPT_RESSOURCES_NON_REP}
            value={departmentSelected._id || ''}
            handleChange={this.handleChangeDepartment}
          />
        </div>
        {/* Affichage des liens en fonction du département */}
        {departmentSelected !== '' && (
          <div className={classes.topMargin}>
            {departmentSelected.ressources.length > 0 && (
              <ul>
                {departmentSelected.ressources.map((res, index) => (
                  <li key={index}>
                    <a target='_blank' rel='noopener noreferrer' className={classes.primaryColorLink} href={res.link}>
                      {this.splitLink(res.link)}
                    </a>
                  </li>
                ))}
              </ul>
            )}
            <p>
              En plus de ces pistes qui peuvent, peut être, t’aider à trouver un stage, on te conseille de travailler au
              maximum ta candidature. Pour cela rien de mieux que profiter des conseils du{' '}
              <a
                target='_blank'
                rel='noopener noreferrer'
                className={classes.primaryColorLink}
                aria-label='Coin des élèves'
                title='Coin des élèves'
                href='https://www.viensvoirmontaf.fr/coin-des-eleves-sommaire/faq-stage-3e/identifier-le-stage-de-mes-reves/'>
                Coin des élèves
              </a>{' '}
              pour faire la meilleure candidature possible.
            </p>
            <p>
              Et pour identifier le stage de tes rêves, l’Onisep propose un quizz pour t’aider à trouver des métiers ou
              des domaines qui peuvent t&apos;intéresser, c’est par{' '}
              <a
                target='_blank'
                rel='noopener noreferrer'
                className={classes.primaryColorLink}
                aria-label='ici : Quizz Onisep'
                title='ici : Quizz Onisep'
                href='https://www.onisep.fr/Decouvrir-les-metiers/Des-metiers-selon-mes-gouts/Quiz-quels-metiers-selon-mes-gouts'>
                ici
              </a>
              .
            </p>
          </div>
        )}
      </div>
    );

    const footer = (
      <Grid container direction='row' justifyContent='space-between' alignItems='center' spacing={3}>
        <a
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Voir le coin des élèves'
          title='Voir le coin des élèves'
          href='https://www.viensvoirmontaf.fr/coin-des-eleves-sommaire/'>
          <Button color='primary' customClass={classes.footerButton}>
            Voir le coin des élèves
          </Button>
        </a>
        <a
          target='_blank'
          rel='noopener noreferrer'
          aria-label="Voir l'application mobile"
          title="Voir l'application mobile"
          href='https://www.viensvoirmontaf.fr/appli-mobile-rapport-de-stage-3e/'>
          <Button color='primary' customClass={classes.footerButton}>
            Voir l&apos;application mobile
          </Button>
        </a>
      </Grid>
    );

    return (
      <ErrorBoundaries>
        <div className={classes.content}>
          <GridContainer justifyContent='center'>
            <ItemGrid xs={12} sm={6}>
              <IconCard
                icon={Face}
                iconColor='red'
                title='Inscription élève'
                content={content}
                footer={footer}
                footerAlign='center'
                footerBorder
              />
            </ItemGrid>
          </GridContainer>
        </div>
      </ErrorBoundaries>
    );
  }
}

StudentRegisterNonRep.propTypes = {
  context: PropTypes.object.isRequired,
};

const WrappedComponent = FormHOC(StudentRegisterNonRep);

export default withStyles(detailsPageStyle)((props) => (
  <Context.Consumer>{(context) => <WrappedComponent {...props} context={context} />}</Context.Consumer>
));
